/**
 * VOXORA markaelemek beagyazott SVG-kent.
 *
 * A jel egy vizszintes savokra vagott "V" - retegvonalak, a 3D nyomtatas
 * kepi utalasa. Beagyazva, hogy ne legyen kulon halozati keres, es hogy
 * a szint a `tone` szabalyozhassa.
 */

type Tone = 'dark' | 'light'
const INK: Record<Tone, string> = { dark: '#fff9ef', light: '#29221e' }

const BANDS = (
  <>
    <rect width="32" height="32" fill="#000" />
    <rect x="0" y="6" width="32" height="4.75" fill="#fff" />
    <rect x="0" y="11.75" width="32" height="4.75" fill="#fff" />
    <rect x="0" y="17.5" width="32" height="4.75" fill="#fff" />
    <rect x="0" y="23.25" width="32" height="4.75" fill="#fff" />
  </>
)

export function VoxoraEmblem({
  size = 32,
  tone = 'dark',
  className
}: {
  size?: number
  tone?: Tone
  className?: string
}): JSX.Element {
  const id = `vx-e-${tone}-${size}`
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} className={className} role="img" aria-label="VOXORA">
      <defs><mask id={id}>{BANDS}</mask></defs>
      <path d="M3 6 H9.5 L16 18.5 L22.5 6 H29 L16 28 Z" fill={INK[tone]} mask={`url(#${id})`} />
    </svg>
  )
}

export function VoxoraLockup({
  size = 28,
  tone = 'dark',
  className
}: {
  size?: number
  tone?: Tone
  className?: string
}): JSX.Element {
  const id = `vx-l-${tone}-${size}`
  const ink = INK[tone]
  return (
    <svg
      viewBox="0 0 150 32"
      height={size}
      width={(150 / 32) * size}
      className={className}
      role="img"
      aria-label="VOXORA"
    >
      <defs><mask id={id}>{BANDS}</mask></defs>
      <path d="M3 6 H9.5 L16 18.5 L22.5 6 H29 L16 28 Z" fill={ink} mask={`url(#${id})`} />
      <g fill="none" stroke={ink} strokeWidth="2.2" strokeLinecap="square" strokeLinejoin="miter">
        <path d="M46 9 L51.25 23 L56.5 9" />
        <rect x="62.6" y="10.1" width="12.8" height="11.8" rx="5.9" />
        <path d="M81.5 9 L92 23 M92 9 L81.5 23" />
        <rect x="98.1" y="10.1" width="12.8" height="11.8" rx="5.9" />
        <path d="M117 23 V9 H123 A3.5 3.5 0 0 1 123 16 H117 M122 16 L127.5 23" />
        <path d="M134 23 L139.25 9 L144.5 23 M135.9 18 H142.6" />
      </g>
    </svg>
  )
}
